import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, MapPin, Mail, Clock, Facebook, Instagram, Youtube, Loader2 } from 'lucide-react';
import { STORE_INFO } from '../mock';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { useState } from 'react';
import { subscribeNewsletter } from '../lib/api';
import { useToast } from '../hooks/use-toast';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const { toast } = useToast();

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      await subscribeNewsletter(email);
      toast({ title: 'Subscribed!', description: 'Thanks for signing up.' });
      setEmail('');
    } catch {
      toast({ title: 'Error', description: 'Could not subscribe.', variant: 'destructive' });
    } finally { setBusy(false); }
  };

  return (
    <footer className="bg-[#0a0a0a] text-neutral-300 mt-20">
      <div className="max-w-7xl mx-auto px-4 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <div className="w-10 h-10 bg-[#bfff00] flex items-center justify-center rounded-md">
              <span className="text-black font-black text-xl">F</span>
            </div>
            <div>
              <div className="font-black text-white text-lg">FITNESS PRO</div>
              <div className="text-[10px] font-bold tracking-[0.2em] text-neutral-400">NUTRITION</div>
            </div>
          </div>
          <p className="text-sm leading-relaxed text-neutral-400">{STORE_INFO.tagline}. Premium supplements at the best prices, backed by expert advice.</p>
          <div className="flex gap-3 mt-5">
            <a href="#" className="w-9 h-9 rounded-full bg-neutral-800 hover:bg-[#bfff00] hover:text-black flex items-center justify-center transition-colors"><Facebook className="w-4 h-4" /></a>
            <a href="#" className="w-9 h-9 rounded-full bg-neutral-800 hover:bg-[#bfff00] hover:text-black flex items-center justify-center transition-colors"><Instagram className="w-4 h-4" /></a>
            <a href="#" className="w-9 h-9 rounded-full bg-neutral-800 hover:bg-[#bfff00] hover:text-black flex items-center justify-center transition-colors"><Youtube className="w-4 h-4" /></a>
          </div>
        </div>

        <div>
          <h4 className="text-white font-bold mb-4 text-sm uppercase tracking-wider">Shop</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/shop?category=protein" className="hover:text-[#bfff00] transition-colors">Protein</Link></li>
            <li><Link to="/shop?category=pre-workout" className="hover:text-[#bfff00] transition-colors">Pre-Workout</Link></li>
            <li><Link to="/shop?category=recovery" className="hover:text-[#bfff00] transition-colors">Recovery</Link></li>
            <li><Link to="/shop?category=fat-burners" className="hover:text-[#bfff00] transition-colors">Fat Burners</Link></li>
            <li><Link to="/shop?category=muscle-builders" className="hover:text-[#bfff00] transition-colors">Muscle Builders</Link></li>
            <li><Link to="/shop" className="hover:text-[#bfff00] transition-colors">All Products</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-bold mb-4 text-sm uppercase tracking-wider">Visit Us</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex gap-3"><MapPin className="w-4 h-4 text-[#bfff00] mt-0.5 shrink-0" /> {STORE_INFO.address}</li>
            <li className="flex gap-3"><Phone className="w-4 h-4 text-[#bfff00] mt-0.5 shrink-0" /> <a href={`tel:${STORE_INFO.phoneRaw}`} className="hover:text-[#bfff00]">{STORE_INFO.phone}</a></li>
            <li className="flex gap-3"><Mail className="w-4 h-4 text-[#bfff00] mt-0.5 shrink-0" /> <a href={`mailto:${STORE_INFO.email}`} className="hover:text-[#bfff00] break-all">{STORE_INFO.email}</a></li>
            <li className="flex gap-3"><Clock className="w-4 h-4 text-[#bfff00] mt-0.5 shrink-0" /> {STORE_INFO.hours}</li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-bold mb-4 text-sm uppercase tracking-wider">Newsletter</h4>
          <p className="text-sm text-neutral-400 mb-3">Get exclusive deals and new product launches in your inbox.</p>
          <form onSubmit={handleSubscribe} className="space-y-2">
            <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Your email" className="bg-neutral-900 border-neutral-700 text-white placeholder:text-neutral-500" />
            <Button type="submit" disabled={busy} className="w-full bg-[#bfff00] text-black hover:bg-[#a8e600] font-bold">
              {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Subscribe'}
            </Button>
          </form>
        </div>
      </div>

      <div className="border-t border-neutral-800">
        <div className="max-w-7xl mx-auto px-4 py-5 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-neutral-500">
          <span>© {new Date().getFullYear()} {STORE_INFO.brandName}. All rights reserved.</span>
          <span>{STORE_INFO.domain}</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
